export class inProcessUrls {
    GET_IN_PROCESS_GTR_URL = "gtr/v1/in-process-gather/all[?ClientName][&ClientId][&TaxYear][&EroSigner][&EngagementType][&DocumentStatus][&PageSize][&PageNo][&SortBy][&SortOrder]";
    DELETE_IN_PROCESS_GTR_URL = "gtr/v1/in-process-gather";
}
